if (!customElements.get('donatemate-widget')) {
  class DonatemateWidget extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.donatemate-widget-button');
      if (!this.button) return;

      this.button.addEventListener('click', this.onClose);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClose);
    }

    onClose = () => {
      this.classList.add('is-hidden');
    };
  }

  customElements.define('donatemate-widget', DonatemateWidget);
}
